import { allPass } from 'ramda';

import { User } from '@/api/auth';
import { CMSGroupParams } from '@/api/cms/base';
import { groupsExclude, groupsInclude } from '@/helpers/cms';

export const getMatchingSection = <T extends CMSGroupParams>(
  sections: T[],
  user?: User
) => {
  return sections.find((section) => {
    if (!user && section.showGuestToggle) return section;
    if (!section.groupsInclude) return null;
    return allPass([groupsInclude(user), groupsExclude(user)])(section);
  });
};

export const getDefaultSection = <T extends CMSGroupParams>(sections: T[]) => {
  return sections.find(
    (section) => !section.groupsExclude && !section.groupsInclude
  );
};
